const prod = [
  {
    path: "/",
    name: "homepage",
    component: () =>
      import(`${process.env.VUE_APP_SITE_URL}/components/views/homepage.vue`),
  },
  {
    path: "/results",
    name: "results",
    props: true,
    component: () =>
      import(`${process.env.VUE_APP_SITE_URL}/components/views/results.vue`),
  },
  {
    path: "/detail",
    name: "detail",
    props: true,
    component: () =>
      import(`${process.env.VUE_APP_SITE_URL}/components/views/detail.vue`),
  },
  {
    path: "/checkout",
    name: "checkout",
    props: true,
    component: () =>
      import(`${process.env.VUE_APP_SITE_URL}/components/views/checkout.vue`),
  },
  {
    path: "/seat-selection",
    name: "seat-selection",
    component: () =>
      import(
        `${process.env.VUE_APP_SITE_URL}/components/views/seat-selection.vue`
      ),
  },
  {
    path: "/ancillaries",
    name: "ancillaries",
    component: () =>
      import(
        `${process.env.VUE_APP_SITE_URL}/components/views/ancillaries.vue`
      ),
  },
  {
    path: "/confirm/:flight_voucher_id/:confirm_code",
    name: "confirm",
    component: () =>
      import(
        `${process.env.VUE_APP_SITE_URL}/components/views/confirm.vue`
      ).then((Confirm) => {
        if (process.env.VUE_APP_MODE != "production")
          window.console.log("async: Confirm View loaded");
        return Confirm;
      }),
    props: (route) => ({
      flight_voucher_id: route.params.flight_voucher_id,
      confirm_code: route.params.confirm_code,
      ignore_redirect: false,
    }),
  },
  {
    path: "/prenotazioni/:flight_voucher_id/:confirm_code",
    name: "prenotazioni",
    component: () =>
      import(
        `${process.env.VUE_APP_SITE_URL}/components/views/confirm.vue`
      ).then((Confirm) => {
        if (process.env.VUE_APP_MODE != "production")
          window.console.log("async: Confirm View loaded");
        return Confirm;
      }),
    props: (route) => ({
      flight_voucher_id: route.params.flight_voucher_id,
      confirm_code: route.params.confirm_code,
      ignore_redirect: true,
    }),
  },
  {
    path: "/termini-e-condizioni",
    name: "terms",
    component: () =>
      import(
        `${process.env.VUE_APP_SITE_URL}/components/views/static-pages/terms.vue`
      ),
  },
  {
    path: "/chi-siamo",
    redirect: "/about",
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(
        `${process.env.VUE_APP_SITE_URL}/components/views/static-pages/about.vue`
      ),
  },
];

export { prod };
